import {v4 as uuidv4} from 'uuid';

const UUID_KEY = '_MADE_WEB_UUID_';

var Perference = {
  storage: localStorage,

  uuid: function() {
    var uuid = this.storage.getItem(UUID_KEY);
    if (!uuid) {
      uuid = uuidv4();
      this.storage.setItem(UUID_KEY, uuid);
    }
    return uuid;
  },

  fcm_token: () => 'YOU_CAN_NOT_USE_FCM_TOKEN_ON_THE_WEP_APP',

  getBool: function(key) {
    const value = this.storage.getItem(key);
    return !value ? false : value.toLowerCase() == 'true';
  },

  setBool: function(key, value) {
    this.storage.setItem(key, value);
  },

  getInt: function(key) {
    const value = this.storage.getItem(key);
    return !value ? 0 : parseInt(value);
  },

  setInt: function(key, value) {
    this.storage.setItem(key, value);
  },

  getFloat: function(key) {
    const value = this.storage.getItem(key);
    return !value ? 0.0 : value;
  },

  setFloat: function(key, value) {
    this.storage.setItem(key, value);
  },

  getString: function(key) {
    const value = this.storage.getItem(key);
    return !value ? '' : value;
  },

  setString: function(key, value) {
    this.storage.setItem(key, value);
  },

  install: function(Vue, options) {
    Vue.prototype.$perf = this;
  },
};

export default Perference;



// WEBPACK FOOTER //
// ./src/config/perference.js